// extracted by mini-css-extract-plugin
module.exports = {"component":"logo-feature-list_component__cKy_8","feature":"logo-feature-list_feature__dE_on","icon":"logo-feature-list_icon___qDsn","text":"logo-feature-list_text__rEqGf"};